import React from 'react';
import {
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Autocomplete
} from '@mui/material';
import genService from 'src/services/generalServices';
import PropTypes from 'prop-types';
import { createFilterOptions } from '@mui/material/useAutocomplete';
import { Controller } from 'react-hook-form';

const OrderGeneral = ({
  register,
  folio,
  errors,
  isLaboral,
  isEscuela,
  idOrden,
  comboGradoEscolar,
  valGradoEscolar,
  setValGradoEscolar,
  setValue,
  setError,
  clearErrors,
  optionsCliente,
  valComboClientes,
  setValComboClientes,
  setIsEscuela,
  setIsLaboral,
  getComboGradoEscolar,
  getComboUsuarioCliente,
  comboUsuarios,
  valComboUsuarios,
  setValComboUsuarios,
  rolUsuario,
  comboEstados,
  comboMunicipios,
  getComboMunicipios,
  control,
  // fechaCitaStr,
  // ordenEstatus
}) => {
  const errorReq = 'Campo requerido.';
  const filtro = createFilterOptions();
  const onlyRead = idOrden > 0 && (rolUsuario !== 'ADMINISTRADOR' && rolUsuario !== 'ANALISTA');

  return (
    <div>
      <Grid container spacing={3}>
        <Grid
          size={{
            md: 6,
            xs: 12
          }}
        >
          <TextField
            label="Folio"
            name="folio"
            value={folio || ''}
            slotProps={{ htmlInput: { readOnly: true } }}
            variant="outlined"
            onLoad={genService.toUpperCase}
            error={!!errors.nombreCliente}
            helperText={errors.nombreCliente?.message}
            fullWidth
            size="small"
          />
        </Grid>
      </Grid>
      {rolUsuario === 'ADMINISTRADOR'
        ? (
          <Grid container spacing={3}>
            <Grid
              size={{
                md: 6,
                xs: 12
              }}
            >
              {idOrden === 0
                ? (
                  <Autocomplete
                    id="combo-box-demo"
                    options={optionsCliente.sort((a, b) => (
                      -b.firstLetter.localeCompare(a.firstLetter)
                    ))}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => (option.label !== undefined ? `${option.label} - (${option.tipoCliente})` : '')}
                    fullWidth
                    value={valComboClientes}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        {...register('regCliente', {
                          required: { value: true, message: errorReq }
                        })}
                        label="Seleccione un Cliente *"
                        variant="outlined"
                        size="small"
                        error={!!errors.regCliente}
                        helperText={errors.regCliente?.message}
                        onInput={genService.toUpperCase}
                      />
                    )}
                    onChange={(event, newValue) => {
                      console.log('nuevo valor del combo cliente', newValue);
                      clearErrors('regCliente');
                      console.log(newValue);
                      setValComboClientes(newValue);
                      setIsLaboral(false);
                      setIsEscuela(false);
                      if (newValue !== null && newValue.tipoCliente === 'Laboral') {
                        setIsLaboral(true);
                      }
                      if (newValue !== null && newValue.tipoCliente === 'Escuela') {
                        setIsEscuela(true);
                        getComboGradoEscolar(newValue.value, undefined);
                      }
                      getComboUsuarioCliente(newValue.value, null);
                      console.log('Combo de usuarios:', comboUsuarios);
                    }}
                  />
                ) : (
                  <TextField
                    name="regCliente"
                    value={`${valComboClientes.label} - (${valComboClientes.tipoCliente})`}
                    variant="outlined"
                    size="small"
                    label="Seleccione un Cliente"
                    fullWidth
                    slotProps={{ htmlInput: { readOnly: true } }}
                  />
                )}
            </Grid>
            <Grid
              size={{
                md: 6,
                xs: 12
              }}
            >
              <Autocomplete
                id="combo-box-demo"
                options={comboUsuarios}
                getOptionLabel={(option) => (option.usuario !== undefined ? `${option.usuario} - (${option.nombreUsuario})` : '')}
                fullWidth
                value={valComboUsuarios}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    {...register('regUsuario', {
                      required: { value: true, message: errorReq }
                    })}
                    label="Seleccione un Usuario *"
                    variant="outlined"
                    size="small"
                    error={!!errors.regUsuario}
                    helperText={errors.regUsuario?.message}
                    onInput={genService.toUpperCase}
                  />
                )}
                onChange={(event, newValue) => {
                  clearErrors('regUsuario');
                  console.log(newValue);
                  setValComboUsuarios(newValue);
                }}
              />
            </Grid>
          </Grid>
        ) : (
          null
        )}
      <Grid container spacing={3}>
        <Grid
          size={{
            md: 6,
            xs: 12
          }}
        >
          <TextField
            label="Nombre *"
            {...register('nombre', {
              required: { value: true, message: errorReq },
              maxLength: { value: 255, message: 'Máximo 255 carácteres.' }
            })}
            slotProps={{ htmlInput: { readOnly: onlyRead } }}
            variant="outlined"
            onInput={genService.toUpperCase}
            error={!!errors.nombre}
            helperText={errors.nombre?.message}
            fullWidth
            size="small"
          />
        </Grid>
        {isLaboral
          ? (
            <Grid
              size={{
                md: 6,
                xs: 12
              }}
            >
              <TextField
                label="Puesto *"
                {...register('puesto', {
                  required: { value: isLaboral, message: errorReq },
                  maxLength: { value: 250, message: 'Máximo 250 carácteres.' }
                })}
                variant="outlined"
                slotProps={{ htmlInput: { readOnly: onlyRead } }}
                onInput={genService.toUpperCase}
                error={!!errors.puesto}
                helperText={errors.puesto?.message}
                fullWidth
                size="small"
              />
            </Grid>
          ) : (
            null
          )}
        {isEscuela
          ? (
            <Grid
              size={{
                md: 6,
                xs: 12
              }}
            >
              <TextField
                label="Matrícula"
                {...register('matricula', {
                  /* required: { value: isEscuela, message: errorReq }, */
                  maxLength: { value: 250, message: 'Máximo 250 carácteres.' }
                })}
                variant="outlined"
                slotProps={{ htmlInput: { readOnly: onlyRead } }}
                onInput={genService.toUpperCase}
                error={!!errors.matricula}
                helperText={errors.matricula?.message}
                fullWidth
                size="small"
              />
            </Grid>
          ) : (
            null
          )}
      </Grid>
      {isEscuela
        ? (
          <Grid container spacing={3}>
            <Grid
              style={{ display: isEscuela ? '' : 'none' }}
              size={{
                md: 6,
                xs: 12
              }}
            >
              { (!onlyRead)
                ? (
                  <Autocomplete
                    id="combo-box-demo"
                    options={comboGradoEscolar.filter((opt) => opt.label)}
                    filterOptions={(options, params) => {
                      const filtered = filtro(options, params);
                      if (params.inputValue.trim() !== '' && rolUsuario === 'ADMINISTRADOR') {
                        filtered.push({
                          value: 0,
                          labelRender: `Agregar: "${params.inputValue.trim()}"`,
                          label: params.inputValue.trim()
                        });
                      }
                      return filtered;
                    }}
                    getOptionLabel={(option) => {
                      if (typeof option === 'string') {
                        return option;
                      }
                      const existValue = comboGradoEscolar.filter((opt) => (
                        opt.label === option.label
                      ));
                      if (existValue.length === 0 && option.value !== undefined) {
                        comboGradoEscolar.push({
                          value: option.value,
                          label: option.label.trim(),
                          labelRender: `${option.label.trim()} - NUEVO`
                        });
                        return (option.label ? option.label : '');
                      }
                      return (option.label ? option.label.trim() : '');
                    }}
                    renderOption={(liProps, option) => {
                      const { key, ...optionProps } = liProps;
                      return (
                        <li key={key} {...optionProps}>
                          {option.labelRender ? option.labelRender : option.label}
                        </li>
                      );
                    }}
                    value={valGradoEscolar}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    freeSolo={rolUsuario === 'ADMINISTRADOR'}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        {...register('gradoEscolar', {
                          required: { value: false, message: errorReq }
                        })}
                        label="Seleccione un Grado Escolar"
                        variant="outlined"
                        size="small"
                        error={!!errors.gradoEscolar}
                        helperText={errors.gradoEscolar?.message}
                        onInput={genService.toUpperCase}
                      />
                    )}
                    onChange={(event, newValue) => {
                      clearErrors('gradoEscolar');
                      console.log('valor del grado escolar', newValue);
                      // Con freeSolo, escribir y presionar Enter entrega un string en vez de
                      // una opción; se convierte a la forma de "Agregar" que espera el backend.
                      if (typeof newValue === 'string') {
                        const label = newValue.trim();
                        const existente = comboGradoEscolar.find((opt) => opt.label === label);
                        setValGradoEscolar(label === '' ? null : (existente || { value: 0, label }));
                        return;
                      }
                      setValGradoEscolar(newValue);
                    }}
                  />
                ) : (
                  rolUsuario === 'CLIENTE'
                    ? (
                      <TextField
                        name="gradoEscolarTxt"
                        label="Grado Escolar"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={valGradoEscolar.label}
                        slotProps={{ htmlInput: { readOnly: onlyRead } }}
                      />
                    ) : (
                      null
                    )
                )}
            </Grid>
            <Grid
              size={{
                md: 2,
                xs: 6
              }}
            >
              <TextField
                label="% de Beca"
                name="pctBeca"
                defaultValue={0}
                inputRef={register('pctBeca', {
                  /* required: { value: isEscuela, message: errorReq }, */
                  maxLength: { value: 3, message: 'Máximo 3 carácteres.' }
                }).ref}
                onChange={(newVal) => {
                  if (newVal.target.value !== undefined
                    && newVal.target.value > 100) {
                    setError('pctBeca', { type: 'custom', message: 'Entre 0 y 100' });
                    setValue('pctBeca', 100);
                  } else {
                    clearErrors();
                  }
                }}
                slotProps={{ htmlInput: { readOnly: onlyRead } }}
                variant="outlined"
                onInput={genService.removeLetters}
                error={errors.pctBeca}
                helperText={errors.pctBeca?.message}
                fullWidth
                size="small"
              />
            </Grid>
          </Grid>
        ) : (
          null
        )}
      <br />
      <Divider />
      <br />
      <div>
        <Grid container spacing={3}>
          <Grid
            size={{
              md: 8,
              xs: 12
            }}
          >
            <TextField
              label={rolUsuario === 'NO_ROL' ? 'Calle *' : 'Calle'}
              {...register('direccion.calle', {
                maxLength: { value: 255, message: 'Máximo 255 caractéres.' },
                required: { value: rolUsuario === 'NO_ROL', message: errorReq }
              })}
              onInput={genService.toUpperCase}
              error={!!errors.direccion?.calle}
              helperText={errors.direccion?.calle?.message}
              variant="outlined"
              fullWidth
              size="small"
              slotProps={{ htmlInput: { readOnly: onlyRead } }}
            />
          </Grid>
          <Grid
            size={{
              md: 2,
              xs: 6
            }}
          >
            <TextField
              label={rolUsuario === 'NO_ROL' ? 'Número *' : 'Número'}
              {...register('direccion.numero', {
                maxLength: { value: 6, message: 'Máximo 6 caractéres.' },
                required: { value: rolUsuario === 'NO_ROL', message: errorReq }
              })}
              onInput={genService.removeLetters}
              error={!!errors.direccion?.numero}
              helperText={errors.direccion?.numero?.message}
              variant="outlined"
              fullWidth
              size="small"
              slotProps={{ htmlInput: { readOnly: onlyRead } }}
            />
          </Grid>
          <Grid
            size={{
              md: 2,
              xs: 6
            }}
          >
            <TextField
              label="Núm Int."
              {...register('direccion.numeroInt', {
                maxLength: { value: 6, message: 'Máximo 6 caractéres.' },
              })}
              onInput={genService.toUpperCase}
              error={!!errors.direccion?.numeroInt}
              helperText={errors.direccion?.numeroInt?.message}
              variant="outlined"
              fullWidth
              size="small"
              slotProps={{ htmlInput: { readOnly: onlyRead } }}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid
            size={{
              md: 6,
              xs: 12
            }}
          >
            <FormControl
              variant="outlined"
              size="small"
              fullWidth
            >
              <InputLabel htmlFor="idEstado-select">
                {
                  errors.idEstado
                    ? <div style={{ color: '#f44336' }}>Seleccione un Estado</div>
                    : <div>Seleccione un Estado</div>
                }
              </InputLabel>
              <Controller
                control={control}
                name="direccion.idEstado"
                rules={{ required: { value: false, message: errorReq } }}
                defaultValue={9}
                render={({ field }) => (
                  <Select
                    {...field}
                    id="idEstado-select"
                    label="Seleccione un Estado"
                    onChange={(evento, newValue) => {
                      getComboMunicipios(newValue.props.value);
                      field.onChange(newValue.props.value);
                    }}
                    readOnly={onlyRead}
                  >
                    {comboEstados.map((edo) => (
                      <MenuItem
                        key={edo.value}
                        value={edo.value}
                      >
                        {edo.label}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
              {
                errors.direccion?.idEstado
                && (
                  <FormHelperText style={{ color: '#f44336' }}>
                    {errors.direccion?.idEstado.message}
                  </FormHelperText>
                )
              }
            </FormControl>
          </Grid>
          <Grid
            size={{
              md: 6,
              xs: 12
            }}
          >
            <FormControl variant="outlined" size="small" fullWidth>
              <InputLabel htmlFor="idMunicipio-select">
                {
                  errors.idMunicipio
                    ? <div style={{ color: '#f44336' }}>Seleccione un Municipio</div> : <div>Seleccione un Municipio</div>
                }
              </InputLabel>
              <Controller
                control={control}
                name="direccion.idMunicipio"
                rules={{ required: { value: false, message: errorReq } }}
                defaultValue=""
                render={({ field }) => (
                  <Select
                    {...field}
                    id="idMunicipio-select"
                    label="Seleccione un Municipio"
                    onChange={(evento, newValue) => {
                      field.onChange(newValue.props.value);
                    }}
                    readOnly={onlyRead}
                  >
                    {comboMunicipios.length === 0
                      ? (
                        <MenuItem
                          key={0}
                          value={0}
                        >
                          Elija un Estado
                        </MenuItem>
                      ) : (
                        comboMunicipios.map((mun) => (
                          <MenuItem
                            key={mun.value}
                            value={mun.value}
                          >
                            {mun.label}
                          </MenuItem>
                        ))
                      )}
                  </Select>
                )}
              />
              {
                errors.direccion?.idMunicipio
                && (
                  <FormHelperText style={{ color: '#f44336' }}>
                    {errors.direccion?.idMunicipio.message}
                  </FormHelperText>
                )
              }
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid
            size={{
              md: 6,
              xs: 12
            }}
          >
            <TextField
              label={rolUsuario === 'NO_ROL' ? 'Colonia *' : 'Colonia'}
              {...register('direccion.colonia', {
                maxLength: { value: 125, message: 'Máximo 125 caractéres.' },
                required: { value: rolUsuario === 'NO_ROL', message: errorReq }
              })}
              onInput={genService.toUpperCase}
              error={!!errors.direccion?.colonia}
              helperText={errors.direccion?.colonia?.message}
              variant="outlined"
              fullWidth
              size="small"
              slotProps={{ htmlInput: { readOnly: onlyRead } }}
            />
          </Grid>
          <Grid
            size={{
              md: 3,
              xs: 6
            }}
          >
            <TextField
              label={rolUsuario === 'NO_ROL' ? 'Código Postal *' : 'Código Postal'}
              {...register('direccion.cp', {
                maxLength: { value: 5, message: 'Máximo 5 caractéres.' },
                pattern: { value: /^[0-9]*$/, message: 'Campo númerico.' },
                required: { value: rolUsuario === 'NO_ROL', message: errorReq }
              })}
              onInput={genService.removeLetters}
              error={!!errors.direccion?.cp}
              helperText={errors.direccion?.cp?.message}
              variant="outlined"
              fullWidth
              size="small"
              slotProps={{ htmlInput: { readOnly: onlyRead } }}
            />
          </Grid>
          <Grid
            size={{
              md: 3,
              xs: 6
            }}
          >
            <TextField
              label="País"
              defaultValue="MEXICO"
              {...register('direccion.pais', {
                maxLength: { value: 125, message: 'Máximo 125 caractéres.' }
              })}
              slotProps={{ htmlInput: { readOnly: true } }}
              onInput={genService.toUpperCase}
              error={!!errors.direccion?.pais}
              helperText={errors.direccion?.pais?.message}
              variant="outlined"
              fullWidth
              size="small"
            />
          </Grid>
        </Grid>
      </div>
      <Grid container spacing={3}>
        <Grid
          size={{
            md: 4,
            xs: 8
          }}
        >
          <TextField
            label="Tel. Primario *"
            {...register('telefonoPrimario', {
              required: { value: true, message: errorReq },
              maxLength: { value: 20, message: 'Máximo 20 caracteres.' },
              pattern: { value: /^[0-9]*$/, message: 'Campo númerico.' }
            })}
            variant="outlined"
            onInput={genService.removeLetters}
            error={!!errors.telefonoPrimario}
            helperText={errors.telefonoPrimario?.message}
            fullWidth
            size="small"
            slotProps={{ htmlInput: { readOnly: onlyRead } }}
          />
        </Grid>
        <Grid
          size={{
            md: 2,
            xs: 4
          }}
        >
          <TextField
            label="Ext."
            {...register('extPrimaria', {
              maxLength: { value: 6, message: 'Máximo 6 caracteres.' },
              pattern: { value: /^[0-9]*$/, message: 'Campo númerico.' }
            })}
            variant="outlined"
            onInput={genService.removeLetters}
            error={!!errors.extPrimaria}
            helperText={errors.extPrimaria?.message}
            fullWidth
            size="small"
            slotProps={{ htmlInput: { readOnly: onlyRead } }}
          />
        </Grid>
        <Grid
          size={{
            md: 4,
            xs: 8
          }}
        >
          <TextField
            label="Tel. Adicional"
            {...register('telefonoSecundario', {
              maxLength: { value: 20, message: 'Máximo 20 caracteres.' },
              pattern: { value: /^[0-9]*$/, message: 'Campo númerico.' }
            })}
            variant="outlined"
            onInput={genService.removeLetters}
            error={!!errors.telefonoSecundario}
            helperText={errors.telefonoSecundario?.message}
            fullWidth
            size="small"
            slotProps={{ htmlInput: { readOnly: onlyRead } }}
          />
        </Grid>
        <Grid
          size={{
            md: 2,
            xs: 4
          }}
        >
          <TextField
            label="Ext."
            {...register('extSecundaria', {
              maxLength: { value: 6, message: 'Máximo 6 caracteres.' },
              pattern: { value: /^[0-9]*$/, message: 'Campo númerico.' }
            })}
            variant="outlined"
            onInput={genService.removeLetters}
            error={!!errors.extSecundaria}
            helperText={errors.extSecundaria?.message}
            fullWidth
            size="small"
            slotProps={{ htmlInput: { readOnly: onlyRead } }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid
          size={{
            md: 6,
            xs: 12
          }}
        >
          <TextField
            label={isLaboral ? 'Email Primario' : 'Email Primario *'}
            {...register('emailPrimario', {
              required: { value: !isLaboral, message: errorReq },
              maxLength: { value: 255, message: 'Máximo 255 caracteres.' },
              pattern: { value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i, message: 'El formato no es correcto.' }
            })}
            variant="outlined"
            onInput={genService.toLowerCase}
            error={!!errors.emailPrimario}
            helperText={errors.emailPrimario?.message}
            fullWidth
            size="small"
            slotProps={{ htmlInput: { readOnly: onlyRead } }}
          />
        </Grid>
        <Grid
          size={{
            md: 6,
            xs: 12
          }}
        >
          <TextField
            label="Email Adicional"
            {...register('emailAdicional', {
              maxLength: { value: 255, message: 'Máximo 255 caracteres.' },
              pattern: { value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i, message: 'El formato no es correcto.' }
            })}
            variant="outlined"
            onInput={genService.toLowerCase}
            error={!!errors.emailAdicional}
            helperText={errors.emailAdicional?.message}
            fullWidth
            size="small"
            slotProps={{ htmlInput: { readOnly: onlyRead } }}
          />
        </Grid>
      </Grid>
      { rolUsuario !== 'NO_ROL'
        ? (
          <Grid container spacing={3}>
            <Grid
              size={{
                md: 12,
                xs: 12
              }}
            >
              <TextField
                label="Observaciones"
                {...register('observaciones')}
                variant="outlined"
                fullWidth
                size="small"
                multiline
                minRows={3}
                onInput={genService.toUpperCase}
                slotProps={{ htmlInput: { readOnly: onlyRead } }}
              />
            </Grid>
          </Grid>
        ) : (
          null
        )}
    </div>
  );
};

OrderGeneral.propTypes = {
  register: PropTypes.func,
  folio: PropTypes.string,
  errors: PropTypes.object,
  isLaboral: PropTypes.bool,
  isEscuela: PropTypes.bool,
  idOrden: PropTypes.number,
  comboGradoEscolar: PropTypes.array,
  valGradoEscolar: PropTypes.object,
  setValGradoEscolar: PropTypes.func,
  setValue: PropTypes.func,
  setError: PropTypes.func,
  clearErrors: PropTypes.func,
  optionsCliente: PropTypes.array,
  valComboClientes: PropTypes.object,
  setValComboClientes: PropTypes.func,
  setIsEscuela: PropTypes.func,
  setIsLaboral: PropTypes.func,
  getComboGradoEscolar: PropTypes.func,
  getComboUsuarioCliente: PropTypes.func,
  comboUsuarios: PropTypes.array,
  valComboUsuarios: PropTypes.object,
  setValComboUsuarios: PropTypes.func,
  rolUsuario: PropTypes.string,
  comboEstados: PropTypes.array,
  comboMunicipios: PropTypes.array,
  getComboMunicipios: PropTypes.func,
  control: PropTypes.object,
  // ordenEstatus: PropTypes.string,
  // fechaCitaStr: PropTypes.string
};

export default OrderGeneral;
